"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _actions = require("../../../actions");
var _Header = _interopRequireDefault(require("../Header"));
var _selectors = require("../../../selectors");
var _types = require("../../../actions/types");
var _BannedUserMessage = _interopRequireDefault(require("../BannedUserMessage"));
var _ValidatingProfileMessage = _interopRequireDefault(require("../ValidatingProfileMessage"));
var _MessageListScreen = _interopRequireDefault(require("../MessageListScreen"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var MessageBoxContent = function MessageBoxContent(_ref) {
  var redirectUserToBannedUserHelpAction = _ref.redirectUserToBannedUserHelpAction,
    _ref$partnerStatus = _ref.partnerStatus,
    partnerStatus = _ref$partnerStatus === void 0 ? null : _ref$partnerStatus,
    _ref$partnerName = _ref.partnerName,
    partnerName = _ref$partnerName === void 0 ? '' : _ref$partnerName,
    isAdview = _ref.isAdview,
    listId = _ref.listId,
    adStatus = _ref.adStatus,
    adSubject = _ref.adSubject,
    adImage = _ref.adImage,
    adPrice = _ref.adPrice;
  var BANNED = _types.PARTNERS_STATUS.BANNED,
    VALIDATING_PROFILE = _types.PARTNERS_STATUS.VALIDATING_PROFILE;
  if (partnerStatus === BANNED) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header["default"], {
        isAdview: isAdview,
        listId: listId,
        adSubject: adSubject,
        adPrice: adPrice,
        adImage: adImage,
        secondHidden: true,
        adStatus: adStatus
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BannedUserMessage["default"], {
        partnerName: partnerName,
        onPress: redirectUserToBannedUserHelpAction,
        isAdview: isAdview
      })]
    });
  }
  if (partnerStatus === VALIDATING_PROFILE) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header["default"], {
        isAdview: isAdview,
        listId: listId,
        adSubject: adSubject,
        adPrice: adPrice,
        adImage: adImage,
        secondHidden: true,
        adStatus: adStatus
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ValidatingProfileMessage["default"], {
        partnerName: partnerName
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageListScreen["default"], {
    isAdview: isAdview
  });
};
MessageBoxContent.propTypes = {
  redirectUserToBannedUserHelpAction: _propTypes.func.isRequired,
  partnerStatus: _propTypes.string,
  partnerName: _propTypes.string
};
var mapStateToProps = function mapStateToProps(state) {
  var _getCurrentPartner = (0, _selectors.getCurrentPartner)(state),
    partnerName = _getCurrentPartner.name;
  var partnerStatus = (0, _selectors.getCurrentPartnerStatus)(state);
  return {
    partnerName: partnerName,
    partnerStatus: partnerStatus
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    redirectUserToBannedUserHelpAction: _actions.redirectUserToBannedUserHelp
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)(MessageBoxContent);